import React, { useEffect, useState } from "react";
import { api, normalizeImageUrl } from "@/lib/api";
import { MapPin, Phone, Mail, Building2 } from "lucide-react";

export default function Tuk() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/tuk").then(r => setItems(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <div className="mb-12 max-w-3xl">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700 mb-3">TUK</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-emerald-950">Tempat Uji Kompetensi (Sewaktu)</h1>
        <p className="mt-4 text-slate-600">Lokasi resmi pelaksanaan asesmen kompetensi bidang realestat.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(t => (
          <div key={t.id} data-testid={`tuk-${t.id}`} className="bg-white rounded-2xl overflow-hidden border border-slate-100 hover:shadow-xl transition-all group">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={normalizeImageUrl(t.photo_url)} alt={t.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6">
              <div className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-widest text-amber-600 mb-2"><Building2 className="w-3.5 h-3.5" /> {t.type}</div>
              <h3 className="font-display font-bold text-lg text-emerald-950 leading-snug">{t.name}</h3>
              <div className="mt-4 space-y-2 text-sm text-slate-600">
                <div className="flex gap-2"><MapPin className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" /> {t.address}, {t.city}</div>
                <div className="flex gap-2"><Phone className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" /> {t.phone}</div>
                <div className="flex gap-2"><Mail className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" /> {t.email}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
